import { all } from "redux-saga/effects";
import { watchExportUsers, watchPrintCurrentPage, watchExporAttemptsAnalytics } from "./watchers";

export function* miscellaneousSagas() {
  yield all([watchExportUsers(), watchExporAttemptsAnalytics(), watchPrintCurrentPage()]);
}
